import React from "react";
import "../../../Assets/css/policy.css";
import "../../../Assets/css/globalStyle.css";
import { Typography } from "@mui/material";

const CreateQuoteStepper = ({ steps, activeStep, setActiveStep }) => {
  return (
    <div className="mx-auto stepper-container text-wraper">
      <div className="mx-auto stepper-container">
        <div className="Stepper_container">
          <div className="steppers">
            {steps.map((field, index) => (
              <div
                className={activeStep === index ? "active" : `step${index}`}
                onClick={() => {
                  if (index < activeStep) setActiveStep(index);
                }}
                key={index}
              >
                {/* <p className={activeStep === index ? "active_text" : "text"}>
                  {field}
                </p> */}
                <Typography
                  variant="body2"
                  sx={{
                    color: activeStep === index ? "black" : "white",
                    fontSize: "0.8rem",
                    margin: 0,
                    fontWeight: activeStep === index ? "bold" : "normal",
                  }}
                >
                  {field}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateQuoteStepper;
